<template>
  <md-table
    v-model="buildings"
    class="table-striped"
    table-header-color="primary"
  >
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Name">
        {{ item.name }}
      </md-table-cell>
      <md-table-cell class="text-right">
        <md-button class="md-just-icon md-primary" @click="viewItem(item.id)">
          <md-tooltip>View Building</md-tooltip>
          <md-icon>forward</md-icon>
        </md-button>
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state md-label="No Buildings Found"></md-table-empty-state>
  </md-table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      buildings: "portfolio/buildings"
    })
  },
  methods: {
    viewItem(id) {
      this.$router.push({
        name: "Building Details",
        params: { buildingId: id }
      });
    }
  }
};
</script>

<style></style>
